/*-----------------------------------------------------------------
- ProfileAddressEditor
-----------------------------------------------------------------*/
export default {
    add  : 'افزودن آدرس جدید',
    edit : 'ویرایش آدرس',
    forms: {
        postal_code  : 'کدپستی',
        title        : 'عنوان آدرس',
        contact_name : 'نام و نام خانوادگی گیرنده',
        mobile       : 'شماره تلفن همراه',
        tel          : 'شماره تلفن ثابت',
        address      : 'آدرس',
        description  : 'توضیحات',
        save_button  : 'ثبت آدرس',
        success_msg  : 'آدرس با موفقیت ثبت شد.',
        province     : 'استان',
        city         : 'شهر',
        neighbourhood: 'محله',
        map          : 'ثبت روی نقشه',
        edit_button  : 'ویرایش آدرس',
    },
};
